<template>
  <div class="container">
    <div class="new_title">News & Stories</div>
    <div class="news_wrapper">
      <div class="news_content">
        <div v-for="(data, index) in newsList" @click="linkToDetail('news', data.newsId)" :key="index">
          <div v-if="data.coverDisplayMode == 'large'" class="news_main_wrapper">
            <div class="news_main_img_content">
              <img class="news_main_img" :src="data.coverUrl" alt="" />
            </div>
            <div class="news_tag">
              <div class="title">{{ data.title }}</div>
              <div class="description">
                {{ data.description }}
              </div>
            </div>
          </div>
          <div v-else class="news">
            <img class="news_img" :src="data.coverUrl" alt="" />
            <div class="news_info">
              <div class="news_title">{{ data.title }}</div>
              <div class="news_description">
                {{ data.description }}
              </div>
              <span class="more">More >></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { computed, ref, reactive, onMounted, toRaw, h, nextTick, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { fetchHomeNewsList } from '@/api/common';

const route = useRoute();
const router = useRouter();
const store = useStore();
const newsList = ref([]);
const getNewsList = () => {
  fetchHomeNewsList().then((res) => {
    if (res.code == 200) {
      newsList.value = res.data;
    }
  });
};

const linkToDetail = (type, id) => {
  router.push(`/${type}/detail/${id}`);
};

onMounted(() => {
  getNewsList();
});
</script>

<style lang="less"></style>

<style lang="less" scoped>
.container {
  margin: 40px auto;
  width: 1080px;
  .new_title {
    font-size: 26px;
    font-weight: bold;
    text-align: left;
    line-height: 28px;
    margin-bottom: 40px;
  }
  .news_wrapper {
    .news_main_wrapper {
      position: relative;
      margin-bottom: 40px;
      cursor: pointer;
      .news_main_img_content {
        padding-bottom: calc(100% * (9 / 16));
        min-height: 200px;
        .news_main_img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 16px;
        }
      }
      .news_tag {
        background: rgba(0, 0, 0, 0.5);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        color: #ffffff;
        bottom: 0;
        position: absolute;
        border-radius: 16px;
        padding: 28px 40px;
        .title {
          font-size: 24px;
          font-weight: bold;
          line-height: 28px;
        }
        .description {
          margin-top: 16px;
          font-size: 14px;
          font-weight: normal;
          line-height: 28px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      @media (max-width: 1080px) {
        .news_tag {
          padding: 12px 20px;
          .title {
            font: 18px;
          }
        }
      }
    }
    .news {
      width: 100%;
      display: flex;
      margin-bottom: 24px;
      background: #f7f7f7;
      padding: 24px;
      border-radius: 16px;
      cursor: pointer;
      @supports (-webkit-transform-style: preserve-3d) {
        &:hover {
          -webkit-transform: translateY(-2px);
          transform: translateY(-2px);
        }
      }
      .news_img {
        width: 300px;
        height: 180px;
        border-radius: 16px;
        margin-right: 24px;
      }
      .news_info {
        flex: 1;
        position: relative;
        .news_title {
          font-size: 24px;
          font-weight: bold;
          line-height: 28px;
          margin-bottom: 16px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .news_description {
          font-size: 14px;
          font-weight: normal;
          line-height: 20px;
          color: #666666;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
        }
        .more {
          margin-top: 16px;
          display: inline-block;
          font-size: 14px;
          font-weight: normal;
          color: #1e7bde;
          cursor: pointer;
          position: absolute;
          right: 0;
          bottom: 0;
          text-decoration: none;
        }
      }
    }
  }
  @media (max-width: 1080px) {
    .news_wrapper {
      width: 100%;
      position: relative;
      .title {
        font-size: 24px;
      }
      .news_content {
        .news {
          padding: 16px;
          .news_img {
            width: 180px;
            height: auto;
          }
          .news_info {
            .news_title {
              font-size: 14px;
              margin-bottom: 8px;
            }
            .news_description {
              line-height: 20px;
              -webkit-line-clamp: 2;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1080px) {
  .container {
    width: 100%;
    padding: 16px;
  }
}
</style>
